import React, { useState } from "react";
import { YotpoModal } from '@yotpo-common/react-b2b-components/modal';
import { texts } from "../../constants";
import { ChooseScreen } from "./ChooseScreen";
import styled from 'styled-components';

const Wrapper = styled.div`
    yotpo-modal::part(panel) {
        width: 1190px;
        height: 796px;
    }
`;

export const ChannelModal = ({openChannelModal = {}, handleOpenCarouselModal, onClose}: any) => {

    const handleMainAction = () => {
        alert('main action')
    }

    const handleSecondaryAction = () => {
        handleOpenCarouselModal(openChannelModal.id)
        onClose();
    }

    return (
        <Wrapper>
            <YotpoModal 
                key={openChannelModal?.id}
                bodyMargins={false}
                open={openChannelModal?.open} 
                onYotpoHide={onClose} 
                modalTitle={texts.MODAL.STEP_1.TITLE}
                onYotpoMainAction={handleMainAction}
                onYotpoSecondaryAction={handleSecondaryAction}
                mainActionLabel='Save'
                secondaryActionLabel='Preview flow'
            >
                <ChooseScreen />
            </YotpoModal>
        </Wrapper>
    )
}